import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import { store } from '../../../../store/store';
import NotificationsButton from './NotificationsButton';

loadDOMComponent({
	selector: 'react-notifications-button',
	// @ts-ignore: TODO: needs typings
	callback: ({ container, context, props }) => {
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<NotificationsButton userId={userId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
